<template>

  <div id="mc_embed_signup">
  <form action="//hatopress.us3.list-manage.com/subscribe/post?u=756f2cd045a9c075f921c09f2&amp;id=0e2446d47f" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">

    <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Enter email address" required>
      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
      <div style="position: absolute; left: -5000px;" aria-hidden="true">
        <input type="text" name="b_756f2cd045a9c075f921c09f2_0e2446d47f" tabindex="-1" value="">
        <input type="text" name="SOURCE" tabindex="-1" value="Embed Form workshops.hatopress.net">
      </div>
      <div class="clear"><input type="submit" value="Sign up" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
      </div>
  </form>
  </div>

</template>

<script>

export default {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*#mc_embed_signup form {display:block; position:relative; text-align:left; padding:10px 0 10px 3%}
#mc_embed_signup h2 {font-weight:bold; padding:0; margin:15px 0; font-size:1.4em;}
#mc_embed_signup input {border:1px solid #999; -webkit-appearance:none;}
#mc_embed_signup input[type=checkbox]{-webkit-appearance:checkbox;}
#mc_embed_signup input[type=radio]{-webkit-appearance:radio;}
#mc_embed_signup input:focus {border-color:#333;}
#mc_embed_signup .button {clear:both; background-color: #aaa; border: 0 none; border-radius:4px; letter-spacing:.03em; color: #FFFFFF; cursor: pointer; display: inline-block; font-size:15px; height: 32px; line-height: 32px; margin: 0 5px 10px 0; padding:0; text-align: center; text-decoration: none; vertical-align: top; white-space: nowrap; width: auto; transition: all 0.23s ease-in-out 0s;}
#mc_embed_signup .button:hover {background-color:#777;}
#mc_embed_signup .small-meta {font-size: 11px;}
#mc_embed_signup .nowrap {white-space:nowrap;}
#mc_embed_signup .clear {clear:none; display:inline;}

#mc_embed_signup label {display:block; font-size:16px; padding-bottom:10px; font-weight:bold;}
#mc_embed_signup input.email {font-family:"Open Sans","Helvetica Neue",Arial,Helvetica,Verdana,sans-serif; font-size: 15px; display:block; padding:0 0.4em; margin:0 4% 10px 0; min-height:32px; width:58%; min-width:130px; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px;}
#mc_embed_signup input.button {display:block; width:35%; margin:0 0 10px 0; min-width:90px;}

#mc_embed_signup div#mce-responses {float:left; top:-1.4em; padding:0em .5em 0em .5em; overflow:hidden; width:90%;margin: 0 5%; clear: both;}
#mc_embed_signup div.response {margin:1em 0; padding:1em .5em .5em 0; font-weight:bold; float:left; top:-1.5em; z-index:1; width:80%;}
#mc_embed_signup #mce-error-response {display:none;}
#mc_embed_signup #mce-success-response {color:#529214; display:none;}
#mc_embed_signup label.error {display:block; float:none; width:auto; margin-left:1.05em; text-align:left; padding:.5em 0;}*/



form {
  max-width: 500px;
  /*display: flex;*/
  /*flex-direction: column;*/
}

input, button {
  vertical-align: bottom;
  display: inline-block;
  border-radius: 5px;
  outline: none;
  font-size: 1rem;
  line-height: 1rem;
  /*height: 2.5rem;*/
  border: 0px solid;
}
input {
  -webkit-appearance:none;
  padding: .5em 1em;
  margin-bottom: 1rem;
  width: 80%;
  outline: none;
  background: #f3f3f3;
}
button, .button {
  display: block;
  cursor: pointer; display: inline-block;
  width: 7rem;
  /*flex-grow: 1;
  flex-shrink: 1;*/
  /*margin: 1rem .5rem;*/
  padding: .5em 1em;
  border-radius: 5px;
  /*margin-left: .5rem;*/
  line-height: 1rem;
  /*border: 1px solid #000;*/
  /*background: hsl(186, 81%, 57%);*/
  cursor: pointer;
  /*background: hsl(159, 89%, 80%);*/
  background: hsl(158, 81%, 57%);
}
button:hover, .button:hover {
  background: hsl(158, 81%, 77%);
}
@media screen and (max-width: 768px) {
  form {
    max-width: 100%;
  }
  input, .button {
    line-height: 1.5;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Mailchimp.vue?44c0d406